<template>
  <div class="news-box">
    <img
      class="img-bj"
      src="@/assets/img/images/question-bj.png"
      alt="question-bj.png"
    />
    <div class="info-box" v-loading="loading">
      <p class="title1">{{ $t("question.title") }}</p>
      <template v-if="newsList.length > 0">
        <div
          class="info-item-box mt20"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="title-box" @click="isShowChange(item, index)">
            <p :class="{ sel: currId === item.id }">
              {{ item.title }}
            </p>
            <i v-if="currId !== item.id" class="el-icon-plus" />
            <i v-if="currId === item.id" class="el-icon-minus" />
          </div>
          <el-collapse-transition>
            <div v-if="currId === item.id" class="title-plan">
              <div v-html="item.content"></div>
            </div>
          </el-collapse-transition>
        </div>
      </template>
      <div v-else class="c-flex1 c-flex-column mb120"><NoData /></div>
    </div>
    <VFooter />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData/index";
import VFooter from "@/components/footer/VFooter";
export default {
  components: {
    NoData,
    VFooter,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      pageTotal: 0,
      newsList: [],
      currId: "",
      pageParams: {
        page: 1,
        rows: 12,
        cateCode: "question", // 焦点图：banner、新闻：news、系统通知：system_notice，平台公告：platform_notice、个人消息：personal_notice、常见问题：question
      },
      loading: false,
    };
  },
  created() {
    this.getNewsList();
  },
  mounted() {},
  methods: {
    typeChange(val) {
      this.currType = val;
    },
    isShowChange(val, index) {
      if (this.newsList[index].id === this.currId) {
        this.currId = "";
      } else {
        this.currId = val.id;
      }
    },
    getNewsList() {
      const _this = this;
      this.loading = true;
      this.$axios.post("/cms/getList", _this.pageParams).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          _this.newsList = res.data.data.rows || [];
          _this.pageTotal = res.data.data.total || 0;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.news-box {
  position: relative;
  background: #f5f6f7;
  .img-bj {
    top: 0;
    left: 0;
    width: 100%;
    height: 763px;
    z-index: 1;
    position: absolute;
  }
  .info-box {
    z-index: 2;
    position: relative;
    padding: 0 260px 120px 260px;
    .title1 {
      text-align: center;
      padding: 120px 0 60px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
    .info-item-box {
      padding: 32px 20px;
      background: #ffffff;
      border-radius: 16px 16px 16px 16px;
      .title-box {
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: space-between;
        .sel {
          color: #4063ff;
        }
        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }
        i {
          font-size: 26px;
        }
      }
      .title-plan {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #e2e3e3;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #1f2329;
      }
    }
    .info-item-box:last-child {
      margin-bottom: 120px;
    }
    .info-item-box:first-child {
      margin: 0px;
    }
  }
}
</style>
